import axios from "axios";

export const client = axios.create(
  process.env.NODE_ENV === "development"
    ? {
        baseURL:
          "https://test.alignmenthealthplan.com/cmspages/custompages/getplan.aspx",
      }
    : {
        baseURL: `${document.location.origin}/cmspages/custompages/getplan.aspx`,
      }
);

client.interceptors.request.use((config) => {
  config.signal = AbortSignal.timeout(60_000);
  return config;
});
